import { render, staticRenderFns } from "./add_filmtype.vue?vue&type=template&id=7c632006&scoped=true"
import script from "./add_filmtype.vue?vue&type=script&lang=js"
export * from "./add_filmtype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c632006",
  null
  
)

export default component.exports